import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import {LicenseManager} from '@ag-grid-enterprise/core'
import {AgGridReact} from '@ag-grid-community/react';
import '@ag-grid-community/styles/ag-grid.css';
import "@ag-grid-community/styles/ag-theme-alpine.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import '../../../component/css/agGridGraph.css';
import {
    API_BSI_DEL,
    API_BSI_IMPORT_FROM_UPLOAD,
    API_BSI_LIST,
    API_UPLOADED_BSI_LIST
} from "../../../service/api.endpoint";
import {Loader} from '@consta/uikit/LoaderCanary';
import {SnackCmp} from "../../../component/snack.cmp";
import cookieCmp from '../../../component/cookie.cmp';
import ModalBsiDiagram from "./modal.bsi.diagram";
import moment from "moment";
import {DatePicker} from "@consta/uikit/DatePicker";
import http from "../../../service/axiosConfig";
import {hasSingleOrgScope, getStoredUsername} from "../../../service/authAccess";

const license = process.env.REACT_APP_AGGRID
if (license) {
    LicenseManager.setLicenseKey(license);
}

interface AgGridGraphProps {
    newRowData: any;
    fromUploaded: boolean;
}

// Получение CSRF токена из cookies
const csrftoken = cookieCmp('csrftoken');

const menuIcon = (kind: 'delete' | 'move' | 'chart') => {
    const icons = {
        delete: '<path d="M9 3h6l1 2h4v2H4V5h4l1-2Zm-2 6h10l-.7 11H7.7L7 9Zm3 2v7h2v-7h-2Zm4 0v7h2v-7h-2Z"/>',
        move: '<path d="M13 5l5 5-5 5v-3H5v-4h8V5Zm-7 11h13v3H6v-3Z"/>',
        chart: '<path d="M5 19h14v2H3V3h2v16Zm3-2V9h3v8H8Zm5 0V5h3v12h-3Zm5 0v-6h3v6h-3Z"/>',
    }
    const colors = {
        delete: '#b42318',
        move: '#175cd3',
        chart: '#027a48',
    }

    return `<span style="
        width:22px;
        height:22px;
        display:inline-flex;
        align-items:center;
        justify-content:center;
        border-radius:5px;
        background:#f8fafc;
        border:1px solid #d0d5dd;
        box-sizing:border-box;
    ">
        <svg viewBox="0 0 24 24" width="15" height="15" fill="${colors[kind]}" aria-hidden="true">
            ${icons[kind]}
        </svg>
    </span>`
}

const GridBsiBsiList: React.FC<AgGridGraphProps> = ({newRowData, fromUploaded}) => {
    const gridRef = useRef<any>();
    const containerStyle = useMemo(() => ({width: '100%', height: '100%'}), []);
    const gridStyle = useMemo(() => ({height: '75vh', minWidth: '400px'}), []);
    const [rowData, setRowData] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isAlert, setIsAlert] = useState<"success" | "alert" | "normal" | "system" | "warning">('success')
    const [alertText, setAlertText] = useState<string>('')
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [bsiFileName, setBsiFileName] = useState<string>()
    const [selectInfo, setSelectInfo] = useState<string>('')
    const [showAlert, setShowAlert] = useState<boolean>(false)

    const today = moment().toDate()
    const lastWeek = moment().subtract(7, 'days').toDate();
    const [valueDateRange, setValueDateRange] = useState<[Date?, Date?] | null>([lastWeek, today]);

    // очистка состояния алерта для возможности повторного вызова
    const handleAlertClose = () => {
        setShowAlert(false)
    };

    const handleModalClose = (value: boolean) => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        if (showAlert) {
            const timeout = setTimeout(() => {
                handleAlertClose();
                setShowAlert(false)
            }, 3000); // Установите желаемое время отображения алерта (в миллисекундах)
            return () => {
                clearTimeout(timeout);
            };
        }
    }, [showAlert]);


    // контекстное меню
    const getContextMenuItems = useCallback((params: any) => {
            var result = []
            if (params.node?.field === "equipage_name") {
                if (!fromUploaded) {
                    result.push(
                        {
                            name: 'Удалить запись БСИ',
                            action: async () => {
                                const bsiID = params.node.allLeafChildren[0].data.bsi_id
                                try {
                                    const additionalData = {username: getStoredUsername()};
                                    const response = await http.delete(`${API_BSI_DEL}/${bsiID}`, {
                                        headers: {
                                            'X-CSRFToken': csrftoken
                                        },
                                        data: additionalData
                                    })
                                    setShowAlert(true)
                                    setIsAlert('success');
                                    setAlertText('Запись успешно удалена')
                                    onGridReady(null);
                                    console.log('Запись успешно удалена:', response.data);
                                } catch
                                    (error: any) {
                                    setShowAlert(true)
                                    setIsAlert('alert');
                                    if (error.response.data.message) {
                                        setAlertText(error.response.data.message)
                                    } else setAlertText('Ошибка при удалении записи')
                                    console.error('Ошибка при удалении записи:', error.response.data);
                                }
                            }
                            ,
                            icon: menuIcon('delete')
                        }
                    )
                } else {
                    result.push(
                        {
                            name: 'Перенести',
                            action: async () => {
                                const bsiID = params.node.allLeafChildren[0].data.bsi_id
                                try {
                                    await http.post(API_BSI_IMPORT_FROM_UPLOAD, {
                                        bsi_id: bsiID
                                    }, {
                                        headers: {
                                            'X-CSRFToken': csrftoken
                                        }
                                    });
                                    setShowAlert(true)
                                    setIsAlert('success');
                                    setAlertText('Запись успешно перенесена')  // ← исправил текст, было "удалена"
                                    onGridReady(null);
                                } catch
                                    (error: any) {
                                    setShowAlert(true)
                                    setIsAlert('alert');
                                    if (error.response.data.message) {
                                        setAlertText(error.response.data.message)
                                    } else setAlertText('Ошибка при переносе записи')
                                }
                            }
                            ,
                            icon: menuIcon('move')
                        }
                    )
                }
                result.push(
                    'separator',
                    {
                        name: 'Открыть график',
                        action: async () => {
                            setBsiFileName(params.node.allLeafChildren[0].data.bsi_id)
                            setSelectInfo(`${params.node.allLeafChildren[0].data.equipage_name} на ${moment(params.node.allLeafChildren[0].data.bsi_date).format('DD.MM.YYYY')}`)
                            setIsModalOpen(true)
                        }
                        ,
                        icon: menuIcon('chart')
                    },
                    // 'copy',
                    // 'separator',
                    // 'chartRange',
                )
            }
            return result;
        },
        []
    );



    const columnDefs = useMemo(() => ([
        {
            field: 'bsi_id',
            headerName: 'id',
            hide: true
        },
        {
            field: 'org_name',
            headerName: 'Подрядчик',
            enableRowGroup: true,
            enablePivot: true,
            rowGroupIndex: fromUploaded ? 0 : undefined,
            initialWidth: 140,
            filter: true,
            hide: fromUploaded || hasSingleOrgScope()
        },
        {
            field: 'bsi_date',
            headerName: 'Дата',
            enableRowGroup: true,
            enablePivot: true,
            rowGroupIndex: fromUploaded ? 1 : 1,
            initialWidth: 150,
            filter: true,
            hide: true
        },
        {
            field: 'equipage_name',
            headerName: 'Экипаж',
            enableRowGroup: true,
            enablePivot: true,
            rowGroupIndex: fromUploaded ? 2 : 2,
            hide: true,
            filter: true,
            initialWidth: 90,
        },
        {
            field: 'fio',
            headerName: 'ФИО ответственного',
            enableRowGroup: true,
            enablePivot: true,
            filter: true,
        },
        {
            field: 'date_log',
            headerName: 'Дата в логах',
            enableRowGroup: true,
            enablePivot: true,
            filter: true,
        },
        {
            field: 'descent_start',
            headerName: 'Начало спуска',
            enableRowGroup: true,
            enablePivot: true,
        },
        {
            field: 'descent_end',
            headerName: 'Завершение спуска',
            enableRowGroup: true,
            enablePivot: true,
            hide: true
        },
        {
            field: 'descent_total',
            headerName: 'Время спуска',
            enableRowGroup: true,
            enablePivot: true,
        },
        {
            field: 'depth',
            headerName: 'Глубина',
            enableRowGroup: true,
            enablePivot: true,
            filter: true,
        },
        {
            field: 'lift_start',
            headerName: 'Начало подьема',
            enableRowGroup: true,
            enablePivot: true,
            hide: true
        },
        {
            field: 'lift_end',
            headerName: 'Завершение подьема',
            enableRowGroup: true,
            enablePivot: true,
            hide: true
        },
        {
            field: 'lift_total',
            headerName: 'Время подьема',
            enableRowGroup: true,
            enablePivot: true,
        },
    ]), [fromUploaded]);

    const getRowId = useMemo(() => {
        return (params: any) => {
            return params.data.id
        };
    }, []);

    const defaultColDef = useMemo(() => {
        return {
            // width: 120,
            sortable: true,
            resizable: true,
            flex: 1
        };
    }, []);

    const onFirstDataRendered = useCallback((params: any) => {
        gridRef.current.api.sizeColumnsToFit();
    }, []);

    const fetchData = async () => {
        try {
            const API = fromUploaded ? API_UPLOADED_BSI_LIST : API_BSI_LIST
            const response = await http.get(API, {
                params: {
                    name: getStoredUsername(),
                    range: {valueDateRange}
                }
            });

            setIsLoading(false);
            return response.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    };

    const onGridReady = async (params: any) => {
        setRowData(await fetchData())
    };

    useEffect(() => {
        setIsLoading(true)
        onGridReady(null); // Вызываем функцию при монтировании компонента
    }, [newRowData, valueDateRange, fromUploaded]);

    const statusBar = useMemo(() => {
        return {
            statusPanels: [
                {statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left'},
            ],
        };
    }, []);


    return (
        <div style={containerStyle}>
            <div className="example-wrapper">
                <div style={{marginBottom: '5px'}}>
                    <span id="eMessage"></span>
                </div>
                <div style={gridStyle} className="ag-theme-alpine">
                    {!fromUploaded && <div>
                        <DatePicker
                            label="Диапазон выборки БСИ"
                            type="date-range"
                            value={valueDateRange}
                            onChange={({value}) => setValueDateRange(value)}
                        />
                    </div>}
                    {isLoading ? <Loader/> :
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowData}
                            columnDefs={columnDefs}
                            animateRows={true}
                            getRowId={getRowId}
                            defaultColDef={defaultColDef}
                            onGridReady={onGridReady}
                            statusBar={statusBar}
                            onFirstDataRendered={onFirstDataRendered}
                            rowGroupPanelShow={'always'}
                            allowContextMenuWithControlKey={true}
                            getContextMenuItems={getContextMenuItems}
                        />
                    }
                </div>
                {showAlert && <SnackCmp alertText={alertText} alertType={isAlert}/>}
            </div>
            {bsiFileName && <ModalBsiDiagram isOpen={isModalOpen}
                                             onClose={handleModalClose}
                                             fileName={bsiFileName}
                                             equipageInfo={selectInfo}/>}
        </div>
    );
};

export default GridBsiBsiList;
